import React from "react";
import { useTranslation } from "react-i18next";
import FormInput from "../../../components/controls/FormInput";
import FormTextArea from "../../../components/controls/FormTextArea";
import FormSelectBox from "../../../components/controls/FormSelectBox";
import Autocomplete from "../../../components/Places/PlacesAutocomplete";
import ImageUploader from "../../../components/controls/ImageUploader";
import { useProducts } from "../../../contexts/Products";
import { useServices } from "../../../contexts/Services";
import { TagIcon } from "@heroicons/react/24/solid";
import Toggle from "../../../components/ui/Toggle";
import DropdownMenu from "../../../components/controls/DropdownMenu";

const GeneralInfoSection = ({
  formData,
  onChange,
  onNestedChange,
  onTempImageChange,
  isService,
}) => {
  const { t } = useTranslation();
  const categories = isService ? useServices() : useProducts();

  const handleLocationSelect = (locationData) => {
    onChange("location", locationData);
  };

  return (
    <section className="bg-white rounded-lg shadow p-4 space-y-4">
      <h2 className="text-xl font-bold text-primary">
        {t("modal.generalInfo")}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormInput
          label={t("modal.productNameFrench")}
          name="nameFr"
          value={formData.nameFr}
          onChange={onChange}
          required
          maxLength={75}
          showMaxLength
        />
        <FormInput
          label={t("modal.productNameEnglish")}
          name="nameEn"
          value={formData.nameEn}
          onChange={onChange}
          required
          maxLength={75}
          showMaxLength
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormTextArea
          label={t("modal.productDescriptionFrench")}
          name="descriptionFr"
          value={formData.descriptionFr}
          onChange={onChange}
          required
          maxLength={400}
          showMaxLength
        />
        <FormTextArea
          label={t("modal.productDescriptionEnglish")}
          name="descriptionEn"
          value={formData.descriptionEn}
          onChange={onChange}
          required
          maxLength={400}
          showMaxLength
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Autocomplete
          onSelect={handleLocationSelect}
          initialAddress={formData.location.formattedAddress || ""}
        />
        <Toggle
          isEnabled={formData.showAddress}
          onToggle={() => onChange("showAddress", !formData.showAddress)}
          labelOn={t("products.addressShown")}
          labelOff={t("products.addressHidden")}
          colorActive="bg-green-500"
          colorInactive="bg-red-500"
          className="toggle-lg"
          title={t("products.showAddress")}
          name="showAddress"
        />
        {/*<FormInput
          label={t("modal.brand")}
          name="brand"
          w
          value={formData.brand}
          onChange={onChange}
        />*/}
      </div>
      <div className="grid grid-cols-2 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-primary">
            {t("modal.category")}{" "}
            <span className="text-muted">{t("modal.required")}</span>
          </label>

          <DropdownMenu
            title={
              categories.find(
                (c) => `${c.value ?? c.id}` === `${formData.category}`
              )?.label ||
              categories.find(
                (c) => `${c.value ?? c.id}` === `${formData.category}`
              )?.name ||
              t("modal.selectCategory")
            }
            isDropdown={true}
            icon={<TagIcon className="w-5 h-5 text-gray-500" />}
            items={categories.map((category) => ({
              label: category.label ?? category.name,
              onClick: () =>
                onChange("category", category.value ?? category.id),
            }))}
          />
        </div>
      </div>

      <ImageUploader
        initialImageUrl={formData.imageUrl || ""}
        onTempImageChange={onTempImageChange}
      />
    </section>
  );
};

export default GeneralInfoSection;
